import React, { createContext, useContext, useState, useCallback } from 'react';

const AlertContext = createContext();

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) throw new Error('useAlert must be used within AlertProvider');
  return context;
};

export const AlertProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const [confirmData, setConfirmData] = useState(null);

  const showAlert = useCallback((message, type = 'info', duration = 4000) => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);

    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, duration);
  }, []);

  const toast = {
    success: (msg) => showAlert(msg, 'success'),
    error: (msg) => showAlert(msg, 'error'),
    info: (msg) => showAlert(msg, 'info'),
    warning: (msg) => showAlert(msg, 'warning')
  };

  const confirm = useCallback((title, message, onConfirm, options = {}) => {
    setConfirmData({ 
      title, 
      message, 
      onConfirm: () => {
        onConfirm();
        setConfirmData(null);
      },
      onCancel: () => setConfirmData(null),
      confirmText: options.confirmText || 'Confirmar',
      cancelText: options.cancelText || 'Cancelar',
      type: options.type || 'info'
    });
  }, []);

  return (
    <AlertContext.Provider value={{ toast, confirm, toasts, confirmData, setToasts }}>
      {children}
    </AlertContext.Provider>
  );
};
